export default __webpack_public_path__ + "static/media/ev-car-hire.e9106264.svg";